import './bootstrap'

import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import Locales from './vue-i18n-locales.generated.js'

import PriceInput from './components/PriceInput.vue'
import Publish from './components/Publish.vue'
import PublishToggle from './components/PublishToggle.vue'
import Delete from './components/Delete.vue'
import ManageAccess from './components/ManageAccess.vue'
import TransactionsChart from './components/TransactionsChart.vue'
import DashboardChart from './components/DashboardChart.vue'
import QuillInput from './components/QuillInput.vue'
import QuillInput2 from './components/QuillInput2.vue'
// import SectionsIndex from './components/SectionsIndex.vue'
import LectureEdit from './components/LectureEdit.vue'
import Message from './components/Message.vue'
import SubpageBlocksEdit from './components/SubpageBlocksEdit.vue'
import PageImagesUpload from './components/PageImagesUpload.vue'
import CommentItem from './components/CommentItem.vue'
import CourseList from './components/CourseList.vue'
import TagManager from './components/TagManager.vue'
import HtmlEditor from './components/HtmlEditorStandalone.vue'
import PromoCodes from './components/PromoCodes.vue'
// import TransactionManager from './components/TransactionManager.vue'
import StudentManager from './components/StudentManager.vue'
// import CourseEdit from './components/CourseEdit.vue'
import CourseCreate from './components/CourseCreate.vue'
// import StudentShow from './components/StudentShow.vue'
import PageSettings from './components/PageSettings.vue'
import ExportCSV from './components/ExportCSV.vue'
import StripeCheckout from './components/StripeCheckout.vue'
import StudentEngagement from './components/StudentEngagement.vue'

import Api from './plugins/app-api'

window.Vue = Vue

import state from './store/app'
const store = new Vuex.Store(state)
Vue.use(vuexI18n.plugin, store)
Vue.i18n.add('en', Locales.en)
Vue.i18n.add('pl', Locales.pl)
const lang = document.documentElement.lang.substr(0, 2)
Vue.i18n.set(lang)

Vue.use(Api)

Vue.component('quill-input', QuillInput)
Vue.component('quill-input2', QuillInput2)
Vue.component('price-input', PriceInput)
Vue.component('publish', Publish)
Vue.component('publish-toggle', PublishToggle)
Vue.component('delete', Delete)
Vue.component('manage-access', ManageAccess)
Vue.component('transactions-chart', TransactionsChart)
Vue.component('dashboard-chart', DashboardChart)
// Vue.component('sections-index', SectionsIndex)
Vue.component('lecture-edit', LectureEdit)
Vue.component('message', Message)
Vue.component('subpage-blocks-edit', SubpageBlocksEdit)
Vue.component('page-images-upload', PageImagesUpload)
Vue.component('comment-item', CommentItem)
Vue.component('course-list', CourseList)
Vue.component('tag-manager', TagManager)
Vue.component('html-editor', HtmlEditor)
Vue.component('promo-codes', PromoCodes)
// Vue.component('transaction-manager', TransactionManager)
Vue.component('student-manager', StudentManager)
// Vue.component('course-edit', CourseEdit)
Vue.component('course-create', CourseCreate)
// Vue.component('student-show', StudentShow)
Vue.component('page-settings', PageSettings)
Vue.component('export-csv', ExportCSV)
Vue.component('stripe-checkout', StripeCheckout)
Vue.component('student-engagement', StudentEngagement)

Sentry.init({
  allowUrls: [
    /https?:\/\/.*\/js\/app\.js/i,
    /https?:\/\/.*\/js\/checkout\.js/i,
    /https?:\/\/.*\/js\/web-app\.js/i,
    /https?:\/\/.*\/js\/exam-app\.js/i,
    /https?:\/\/.*\/js\/player-app\.js/i,
    /https?:\/\/.*\/js\/manifest\.js/i,
    /https?:\/\/.*\/js\/vendor\.js/i,
    /https?:\/\/.*\/js\/app2\.js/i,
    /https?:\/\/.*\/js\/quill-s\.js/i,
  ],
  environment: process.env.MIX_ENV || 'local',
  dsn: 'https://bf89147d9a8a451abb5560c7cca457dd@glitchtip.skyier.pl/2',
  integrations: [
    new Integrations.Vue({
      Vue,
      attachProps: true,
      logErrors: true,
    }),
    new Integrations.CaptureConsole({
      levels: ['error'],
    }),
  ],
})

const app = new Vue({
  el: '#app',
  store,
})
